import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from "vue-router"
import routes from './routes/index'
import VueMask from 'v-mask'
import './plugins/vuetify-mask'
import money from 'vuejs-money'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueMask)
Vue.use(money)

const router = new VueRouter({
  mode: 'history',
  routes,
})

new Vue({
  el: '#app',
  vuetify,
  router,
  render: h => h(App)
})
